export interface Movie {
  id: number;
  title: string;
  category: string;
  subcategory: string;
  image: string;
  rating: number;
  year: number;
  region: string;
  description: string;
  actors: string[];
  director: string;
  updateStatus: string;
  duration: string;
  language: string;
  tags: string[];
  viewCount: number;
  releaseDate: string;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-slideshow-line' },
];

export const subcategories: Record<string, string[]> = {
  movie: ['动作', '喜剧', '爱情', '科幻', '恐怖', '悬疑', '战争', '剧情', '犯罪', '奇幻'],
  tv: ['国产剧', '港台剧', '日韩剧', '欧美剧', '网剧', '短剧'],
  variety: ['真人秀', '脱口秀', '音乐', '竞技', '访谈', '美食', '旅行'],
  anime: ['国产动漫', '日本动漫', '欧美动漫', '剧场版'],
  documentary: ['自然', '历史', '科技', '人文', '军事', '探索'],
};

export const featuredMovies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subcategory: '科幻',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20a%20giant%20planet%20and%20spacecraft%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20atmosphere%20with%20warm%20orange%20accents%2C%20movie%20poster%20aesthetic%20with%20Chinese%20title%20space&width=800&height=1120&seq=movie-feat-01&orientation=portrait',
    rating: 9.2,
    year: 2025,
    region: '中国大陆',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代挺身而出，展开一场生死未卜的冒险。本片是流浪地球系列的第三部作品，延续了前作的宏大叙事和震撼视效。',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    director: '郭帆',
    updateStatus: '已完结',
    duration: '148分钟',
    language: '汉语普通话',
    tags: ['科幻', '灾难', '冒险', '国产巨制'],
    viewCount: 23560000,
    releaseDate: '2025-02-10',
  },
  {
    id: 2,
    title: '繁城之下',
    category: 'tv',
    subcategory: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20poster%20with%20ancient%20city%20scenery%20and%20traditional%20rooftops%2C%20misty%20atmosphere%2C%20warm%20lantern%20light%2C%20cinematic%20film%20poster%20style%2C%20rich%20textures%20and%20muted%20earth%20tones&width=800&height=1120&seq=movie-feat-02&orientation=portrait',
    rating: 9.5,
    year: 2024,
    region: '中国大陆',
    description: '明朝万历年间，江南小城接连发生离奇命案。小捕快曲三更在调查过程中，逐渐揭开了一个关于二十年前灭门惨案的惊天秘密。全剧悬疑氛围浓厚，人物刻画细腻。',
    actors: ['白宇帆', '宁理', '向涵之', '刘怡潼'],
    director: '王铮',
    updateStatus: '全12集',
    duration: '45分钟/集',
    language: '汉语普通话',
    tags: ['悬疑', '古装', '探案', '高分推荐'],
    viewCount: 18720000,
    releaseDate: '2024-10-13',
  },
  {
    id: 3,
    title: '封神第二部',
    category: 'movie',
    subcategory: '奇幻',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20warriors%20in%20elaborate%20armor%2C%20mythical%20creatures%2C%20epic%20battle%20scene%20backdrop%2C%20dramatic%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20composition&width=800&height=1120&seq=movie-feat-03&orientation=portrait',
    rating: 8.8,
    year: 2025,
    region: '中国大陆',
    description: '殷商末年，纣王暴虐无道。姬发率领西岐大军讨伐朝歌，神仙妖魔各显神通，一场惊天动地的封神之战就此展开。宏大的神话史诗续作。',
    actors: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    director: '乌尔善',
    updateStatus: '已完结',
    duration: '155分钟',
    language: '汉语普通话',
    tags: ['奇幻', '史诗', '神话', 'IMAX'],
    viewCount: 31200000,
    releaseDate: '2025-07-26',
  },
  {
    id: 4,
    title: '乘风破浪的姐姐 第六季',
    category: 'variety',
    subcategory: '真人秀',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20elegant%20women%20on%20a%20glamorous%20stage%2C%20spotlight%20effects%2C%20fashionable%20outfits%2C%20vibrant%20and%20energetic%20atmosphere%2C%20warm%20golden%20and%20pink%20lighting%2C%20entertainment%20show%20aesthetic&width=800&height=1120&seq=movie-feat-04&orientation=portrait',
    rating: 8.5,
    year: 2025,
    region: '中国大陆',
    description: '全新一季乘风破浪的姐姐重磅回归！三十位30+姐姐集结，通过舞台竞演展现女性力量与魅力。本季赛制全面升级，国际姐姐加盟，精彩程度再创新高。',
    actors: ['宁静', '张雨绮', '万茜', '蓝盈莹', '金晨'],
    director: '芒果TV',
    updateStatus: '更新至第8期',
    duration: '120分钟/期',
    language: '汉语普通话',
    tags: ['真人秀', '音乐', '竞技', '女性'],
    viewCount: 45800000,
    releaseDate: '2025-05-16',
  },
];

export const latestMovies: Movie[] = [
  {
    id: 5,
    title: '清明上河图密码',
    category: 'tv',
    subcategory: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20inspired%20by%20Song%20Dynasty%20painting%2C%20ancient%20Chinese%20street%20scene%20with%20merchants%20and%20citizens%2C%20warm%20ink%20wash%20painting%20aesthetic%2C%20elegant%20traditional%20art%20style%2C%20soft%20beige%20and%20brown%20tones&width=800&height=1120&seq=movie-latest-01&orientation=portrait',
    rating: 8.9,
    year: 2025,
    region: '中国大陆',
    description: '北宋汴京城内，一幅《清明上河图》中隐藏着惊天秘密。画师张择端意外卷入连环案件之中，与开封府联手探案，揭开画中824个人物背后的故事。',
    actors: ['张颂文', '白百何', '周一围', '林家川'],
    director: '杨帆',
    updateStatus: '更新至16集',
    duration: '45分钟/集',
    language: '汉语普通话',
    tags: ['古装', '悬疑', '探案', '宋朝'],
    viewCount: 12800000,
    releaseDate: '2025-07-15',
  },
  {
    id: 6,
    title: '哥斯拉大战金刚3：新帝国',
    category: 'movie',
    subcategory: '动作',
    image: 'https://readdy.ai/api/search-image?query=Epic%20monster%20movie%20poster%20with%20giant%20creatures%20battling%20in%20a%20destroyed%20city%2C%20cinematic%20composition%2C%20dramatic%20lighting%20with%20fire%20and%20smoke%2C%20dark%20atmosphere%20with%20orange%20explosions%2C%20blockbuster%20film%20aesthetic&width=800&height=1120&seq=movie-latest-02&orientation=portrait',
    rating: 8.3,
    year: 2025,
    region: '美国',
    description: '全新威胁从地心世界崛起，哥斯拉与金刚必须再次联手，面对前所未有的敌人。两大泰坦巨兽的命运与人类世界的存亡紧密相连。',
    actors: ['丹·史蒂文斯', '丽贝卡·豪尔', '布莱恩·泰里·亨利'],
    director: '亚当·温加德',
    updateStatus: 'HD高清',
    duration: '135分钟',
    language: '英语',
    tags: ['动作', '科幻', '怪兽', '好莱坞'],
    viewCount: 19600000,
    releaseDate: '2025-03-29',
  },
  {
    id: 7,
    title: '大侦探 第十季',
    category: 'variety',
    subcategory: '真人秀',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20detective%20mystery%20variety%20show%20poster%20with%20silhouettes%20of%20investigators%20in%20a%20dimly%20lit%20room%2C%20magnifying%20glass%20and%20clue%20elements%2C%20suspenseful%20atmosphere%2C%20warm%20spotlight%20effects%2C%20mystery%20theme&width=800&height=1120&seq=movie-latest-03&orientation=portrait',
    rating: 9.0,
    year: 2025,
    region: '中国大陆',
    description: '经典推理综艺回归！何炅、撒贝宁领衔的侦探团再度集结，每期一个全新案件，沉浸式实景搜证，烧脑程度全面升级。',
    actors: ['何炅', '撒贝宁', '白敬亭', '王鸥', '张若昀'],
    director: '芒果TV',
    updateStatus: '更新至第6期',
    duration: '100分钟/期',
    language: '汉语普通话',
    tags: ['推理', '真人秀', '悬疑', '烧脑'],
    viewCount: 32100000,
    releaseDate: '2025-06-20',
  },
  {
    id: 8,
    title: '长安的荔枝',
    category: 'tv',
    subcategory: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Tang%20Dynasty%20historical%20drama%20poster%20with%20ancient%20Changan%20city%20and%20flying%20horse%20rider%20carrying%20lychee%2C%20warm%20golden%20sunset%20lighting%2C%20traditional%20Chinese%20painting%20aesthetic%2C%20elegant%20composition&width=800&height=1120&seq=movie-latest-04&orientation=portrait',
    rating: 9.3,
    year: 2025,
    region: '中国大陆',
    description: '天宝十四年，长安城的小吏李善德突然接到一个任务：要在贵妃诞日之前，从岭南运来新鲜荔枝。荔枝"一日色变，两日香变，三日味变"，而岭南距长安五千余里，看似不可能完成的任务，就此展开。',
    actors: ['雷佳音', '岳云鹏', '张若昀'],
    director: '曹盾',
    updateStatus: '全24集',
    duration: '42分钟/集',
    language: '汉语普通话',
    tags: ['古装', '历史', '喜剧', '马伯庸'],
    viewCount: 25600000,
    releaseDate: '2025-04-18',
  },
  {
    id: 9,
    title: '咒术回战 第三季',
    category: 'anime',
    subcategory: '日本动漫',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20a%20powerful%20sorcerer%20character%20with%20dark%20hair%20and%20supernatural%20energy%20effects%2C%20dynamic%20action%20pose%2C%20vibrant%20contrast%20of%20dark%20shadows%20and%20glowing%20cursed%20energy%2C%20anime%20illustration%20style&width=800&height=1120&seq=movie-latest-05&orientation=portrait',
    rating: 9.4,
    year: 2025,
    region: '日本',
    description: '涉谷事变之后，咒术界陷入前所未有的混乱。虎杖悠仁与伙伴们面对更强大的诅咒与更黑暗的阴谋，咒术高专的命运将走向何方？',
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美'],
    director: '朴性厚',
    updateStatus: '更新至第5集',
    duration: '24分钟/集',
    language: '日语',
    tags: ['热血', '战斗', '超能力', 'JUMP'],
    viewCount: 38900000,
    releaseDate: '2025-07-05',
  },
  {
    id: 10,
    title: '我们的星球 第三季',
    category: 'documentary',
    subcategory: '自然',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20aerial%20view%20of%20Earth%20landscapes%2C%20lush%20forests%20and%20crystal%20clear%20oceans%2C%20diverse%20wildlife%20in%20natural%20habitat%2C%20warm%20golden%20hour%20lighting%2C%20breathtaking%20natural%20beauty%2C%20cinematic%20documentary%20style&width=800&height=1120&seq=movie-latest-06&orientation=portrait',
    rating: 9.7,
    year: 2025,
    region: '英国',
    description: '全球顶级自然纪录片系列回归，以8K超高清技术记录地球上最壮观的自然奇观与最珍稀的野生动物。本季聚焦气候变化下的生态系统变迁。',
    actors: ['大卫·爱登堡'],
    director: 'BBC Studios',
    updateStatus: '全8集',
    duration: '50分钟/集',
    language: '英语',
    tags: ['自然', '纪录片', 'BBC', '8K'],
    viewCount: 15300000,
    releaseDate: '2025-01-20',
  },
  {
    id: 11,
    title: '破云',
    category: 'movie',
    subcategory: '悬疑',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20a%20detective%20standing%20in%20rainy%20city%20street%20at%20night%2C%20neon%20reflections%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20suspenseful%20mood%2C%20cinematic%20film%20noir%20style%20with%20cool%20and%20warm%20light%20contrast&width=800&height=1120&seq=movie-latest-07&orientation=portrait',
    rating: 8.6,
    year: 2025,
    region: '中国大陆',
    description: '缉毒警察江停在一次行动中遭遇意外，醒来后发现自己的身份已被调换。为查明真相，他潜入贩毒集团内部，展开了一场惊心动魄的卧底行动。',
    actors: ['刘昊然', '王俊凯', '张译'],
    director: '文牧野',
    updateStatus: 'HD高清',
    duration: '128分钟',
    language: '汉语普通话',
    tags: ['犯罪', '悬疑', '动作', '缉毒'],
    viewCount: 8920000,
    releaseDate: '2025-06-12',
  },
  {
    id: 12,
    title: '小欢喜2',
    category: 'tv',
    subcategory: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20poster%20with%20a%20warm%20family%20gathering%20scene%2C%20parents%20and%20teenagers%20in%20a%20cozy%20living%20room%2C%20soft%20warm%20lighting%2C%20heartwarming%20atmosphere%2C%20slice%20of%20life%20aesthetic%2C%20modern%20Chinese%20home&width=800&height=1120&seq=movie-latest-08&orientation=portrait',
    rating: 9.1,
    year: 2025,
    region: '中国大陆',
    description: '曾经的高中生们步入了大学校园，新的挑战接踵而至。方一凡、乔英子、季杨杨在各自的道路上成长，而家长们也面临着中年生活的新课题。',
    actors: ['黄磊', '海清', '陶虹', '沙溢', '周奇'],
    director: '汪俊',
    updateStatus: '更新至20集',
    duration: '45分钟/集',
    language: '汉语普通话',
    tags: ['家庭', '教育', '成长', '温情'],
    viewCount: 21400000,
    releaseDate: '2025-05-01',
  },
];

export const allMovies: Movie[] = [...featuredMovies, ...latestMovies];

export const aboutInfo = {
  brandName: '51影院',
  slogan: '海量影视，免费畅享',
  introduction: '51影院是国内领先的免费在线影视平台，聚合久久影院、悠久影院、九九影院、55影院等多家优质资源，致力于为广大影视爱好者提供最新、最全、最高清的影视内容。无需注册、无需付费，即可畅享海量电影、电视剧、综艺节目和动漫资源。',
  history: '自2020年创立以来，51影院始终秉持"让每个人都能免费看好片"的理念，从最初的小型影视导航站逐步发展成为覆盖全类型影视内容的综合性平台。五年间，平台累计服务超过5000万用户，日均访问量突破百万，已成为中文互联网最具影响力的免费影视平台之一。',
  values: [
    { title: '内容全面', description: '涵盖电影、电视剧、综艺、动漫、纪录片等全类型，从经典老片到最新热播一网打尽。' },
    { title: '高清画质', description: '提供1080P及4K超高清画质资源，给您影院级的观影体验。' },
    { title: '无需注册', description: '即点即看，无需繁琐的注册流程，保护您的隐私安全。' },
    { title: '持续更新', description: '7x24小时不间断更新，追剧不等待，热门内容第一时间上线。' },
  ],
  reputation: [
    { platform: '百度口碑', rating: 4.8, comment: '资源很全，更新速度快，画质清晰，一直在用！' },
    { platform: '知乎', rating: 4.7, comment: '51影院的分类做得很好，找片特别方便，推荐给大家。' },
    { platform: '豆瓣', rating: 4.6, comment: '免费不用注册这点太赞了，片源质量也不错。' },
    { platform: '微博', rating: 4.8, comment: '全网影视资源最全的平台之一，追剧党必备！' },
    { platform: '小红书', rating: 4.7, comment: '界面清爽没有广告弹窗，观影体验很舒服。' },
  ],
  contact: {
    email: 'service@51cinema.com',
    wechat: 'cinema51_official',
    qq: '3051200000',
    workingHours: '周一至周日 9:00 - 22:00',
  },
  faq: [
    { question: '51影院需要注册吗？', answer: '不需要。51影院所有内容均可免费在线观看，无需注册登录，打开即可播放。' },
    { question: '51影院支持哪些设备观看？', answer: '51影院支持电脑、平板、手机等多种设备，适配各种屏幕尺寸，随时随地畅享影视。' },
    { question: '影视资源更新速度快吗？', answer: '非常快。51影院与久久影院、悠久影院等平台同步更新，热门剧集上线后最快1小时内即可观看。' },
    { question: '视频画质如何？', answer: '提供标清、高清、超清多种画质选择，大部分热门资源支持1080P和4K超高清播放。' },
    { question: '有没有广告？', answer: '51影院以用户体验为核心，页面清爽简洁，不设弹窗广告和强制广告，保障流畅观影。' },
    { question: '可以下载视频吗？', answer: '51影院为在线观看平台，暂不支持视频下载。但您可随时在线观看，无需占用设备存储空间。' },
  ],
};